import o from "./index669.js";
import { withInstall as t } from "./index604.js";
const p = t(o);
export {
  p as ElPopper,
  p as default
};
